import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { queryKeys } from './query';

export function useLocalsQuery() {
  return useQuery({ queryKey: queryKeys.locals, queryFn: () => api.locals.list() });
}

export function useLocalQuery(localId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.local(localId ?? ''),
    queryFn: () => api.locals.get(localId!),
    enabled: !!localId,
  });
}
